/**
 * Exportar a `.gemba.json` desde cualquier lugar (inicio, barra del proyecto, historial). Si el
 * espacio de trabajo tiene datos reales, pide confirmación y el archivo lo declara (doc. 02 §8).
 */

import { exportarDocumento, nombreDeArchivo } from '../../persistencia/archivo';
import { ahoraIso } from '../formato';
import { M } from '../mensajes/es-PE';
import { avisar } from '../ui/avisos';
import { confirmar } from '../ui/Confirmaciones';
import { descargarTexto, VERSION_APP } from './descargas';
import { repositorio } from './repositorio';

export async function exportarArchivo(
  documento: unknown,
  nombre: string,
  espacioDeTrabajoId: string,
): Promise<boolean> {
  const espacio = await repositorio().obtenerEspacioDeTrabajo(espacioDeTrabajoId);
  const datosReales = espacio?.contieneDatosReales ?? false;
  if (
    datosReales &&
    !(await confirmar({
      titulo: M.organizacion.exportarTitulo,
      texto: M.organizacion.exportarTexto,
      confirmar: M.organizacion.exportarConfirmar,
    }))
  )
    return false;
  const archivo = nombreDeArchivo({ nombre });
  descargarTexto(archivo, exportarDocumento(documento, VERSION_APP, ahoraIso(), datosReales));
  avisar(M.proyecto.exportado(archivo), 'exito');
  return true;
}
